import script from "./ProductBrandwise.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBrandwise.vue?vue&type=script&setup=true&lang=js"

import "./ProductBrandwise.vue?vue&type=style&index=0&id=58b8c640&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b8c640"]])

export default __exports__